import { Icon } from "../components/Icon.js";

export function WebhooksPage() {
  return (
    <div className="bg-surface-container border border-outline-variant rounded-xl p-xl flex flex-col items-center text-center gap-md min-h-[420px] justify-center">
      <Icon name="webhook" className="text-primary-fixed-dim/60" style={{ fontSize: "56px" }} />
      <h1 className="text-display-xl text-on-background">Webhooks</h1>
      <p className="max-w-md text-body-base text-on-surface-variant">
        Google Calendar watch channels and their renewal countdowns will show here once a Gmail connector is active.
      </p>
      <span className="font-mono text-label-xs uppercase tracking-widest text-on-surface-variant border border-outline-variant rounded-lg px-3 py-1.5 mt-2">
        Activates with first Gmail
      </span>
    </div>
  );
}
